export enum JobRequiredExperienceEnum {
  "entry" = 1,
  "intermediate" = 2,
  "expert" = 3,
  "specialist" = 4,
}
